import { HttpContext } from "@angular/common/http";
import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { Observable } from "rxjs";
import {
  CvParameter,
  CvParameterControllerService,
  EntityModelCvParameter,
  PagedModelEntityModelCvParameter
} from "../../../../modules/lipidcompass-backend-client";
import { CrudAdapter } from "../../layouts/crud-table/crud-adapter";
import { ColumnFilterType, TableColumn } from "../../_models/table-column";
import { LoggingService } from "../../_services/logging.service";
import { CrudTableComponent } from "../../layouts/crud-table/crud-table.component";
import { ButtonModule } from "primeng/button";
import { ToastModule } from "primeng/toast";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-admin-cvparameters",
  templateUrl: "./admin-cvparameters.component.html",
  styleUrls: ["./admin-cvparameters.component.css"],
  standalone: true,
  imports: [ButtonModule, CrudTableComponent, FormsModule, ToastModule]
})
export class AdminCvParametersComponent implements OnInit {
  private controller = inject(CvParameterControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private loggingService = inject(LoggingService);

  columns: TableColumn[] = [];
  filterFields: string[] = [];
  crudAdapter!: CrudAdapter<
    PagedModelEntityModelCvParameter,
    EntityModelCvParameter
  >;
  bulkUpdating = false;

  ngOnInit() {
    this.columns = [
      /*{ field: "id", header: "Id", filterType: ColumnFilterType.Text },*/
      {
        field: "id",
        header: "Id",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "transactionUuid",
        header: "Transaction",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "accession",
        header: "Accession",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "name",
        header: "Name",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "value",
        header: "Value",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "referenceType",
        header: "Type",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "cvParameterType",
        header: "CvParam Type",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "booleanValue",
        header: "Boolean Value",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "longValue",
        header: "Long Value",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "doubleValue",
        header: "Double Value",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      },
      {
        field: "visibility",
        header: "Visibility",
        filterType: ColumnFilterType.Text,
        content: value => value,
        visible: true
      }
    ];
    this.filterFields = this.columns.map(value => {
      return value.field;
    });
    this.crudAdapter = new CvParameterCrudAdapter(
      this.controller,
      this.messageService,
      this.confirmationService,
      this.loggingService
    );
  }

  bulkUpdateCvParameterNames() {
    this.bulkUpdating = true;
    this.controller.cvParameterBulkUpdateNames().subscribe({
      next: result => {
        const count = Object.keys(result).length;
        this.messageService.add({
          severity: "success",
          summary: "Bulk update complete",
          detail: `Updated names for ${count} accession(s).`
        });
        this.bulkUpdating = false;
      },
      error: err => {
        this.messageService.add({
          severity: "error",
          summary: "Bulk update failed",
          detail: err?.message ?? "An unexpected error occurred."
        });
        this.bulkUpdating = false;
      }
    });
  }
}
class CvParameterCrudAdapter extends CrudAdapter<
  PagedModelEntityModelCvParameter,
  EntityModelCvParameter
> {
  constructor(
    private controller: CvParameterControllerService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    loggingService: LoggingService
  ) {
    super(messageService, confirmationService, loggingService);
  }

  get(
    page?: number,
    size?: number,
    sort?: Array<string>,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<PagedModelEntityModelCvParameter> {
    return this.controller.cvParameterGet(
      page,
      size,
      sort,
      observe,
      reportProgress,
      options
    );
  }

  extractEntries(entries: any): EntityModelCvParameter[] {
    return <EntityModelCvParameter[]>entries?._embedded?.cvParameters;
  }

  saveSingle(
    entity: EntityModelCvParameter,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<EntityModelCvParameter> {
    return this.controller.cvParameterSaveSingle(
      <CvParameter>entity,
      observe,
      reportProgress,
      options
    );
  }
  deleteById(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/hal+json";
      context?: HttpContext;
    }
  ): Observable<object> {
    return this.controller.cvParameterDeleteById(id, observe, reportProgress, options);
  }
}
